/**
 * Table Colors CSS Rules Generator
 *
 * Function for generating CSS rules from table colors control values
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { applyFilters } from '@wordpress/hooks';

import type { TableColorsValues } from '../types';

/**
 * Generate table colors CSS rules from TableColorsValues
 */
export const generateTableColorsCSSRules = (
	values: TableColorsValues,
	blockSelector: string = '',
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Border color for table rows and header cells
	if ( values.borderColor ) {
		styles[
			`${ blockSelector } .redfox-thank-you-order-details__header`
		] = `border-bottom-color: ${ values.borderColor }`;
		styles[
			`${ blockSelector } .redfox-thank-you-order-details__body`
		] = `border-bottom-color: ${ values.borderColor }`;
		styles[
			`${ blockSelector } .redfox-thank-you-order-details__summary .redfox-thank-you-order-details__summary-item--total`
		] = `border-top-color: ${ values.borderColor }`;
	}

	// Header color
	if ( values.headerColor ) {
		styles[
			`${ blockSelector } .redfox-thank-you-order-details__header-cell`
		] = `color: ${ values.headerColor }`;
	}

	// Total row color
	if ( values.totalRowColor ) {
		styles[
			`${ blockSelector } .redfox-thank-you-order-details__summary-item--total`
		] = `color: ${ values.totalRowColor }`;
	}

	/**
	 * Filter table colors CSS rules
	 *
	 * Allows modification of generated table colors CSS rules
	 *
	 * @since 1.0.0
	 *
	 * @param {Record<string, string>} styles - Generated CSS rules
	 * @param {TableColorsValues} values - Table colors control values
	 * @param {string} blockSelector - Block selector for scoping
	 */
	return applyFilters(
		'redfox_thank_you.table_colors.css_rules',
		styles,
		values,
		blockSelector,
	) as Record< string, string >;
};
